import type {User} from "../entities/User";
import {myAxios} from "../util/myAxios";
import {eventUrl} from './base';

export function getMe(): Promise<User> {
  return myAxios()
    .then(axios => axios.get('/api/v1/me'))
    .then(response => response.data);
}

export function register(user: User): Promise<User> {
  return myAxios()
    .then(axios => axios.post(eventUrl(`/users`), user))
    .then(response => response.data);
}

export function updateUser(user: User): Promise<User> {
  return myAxios()
    .then(axios => axios.put(eventUrl(`/users/${user.id}`), user))
    .then(response => response.data);
}

